module.exports = __webpack_public_path__ + "static/media/icon5.6336af3e.svg";